import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import fetch_45global from "/app/middleware/fetch.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  fetch_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "admin-auth": () => import("/app/middleware/admin-auth.ts"),
  "admin-panel-auth": () => import("/app/middleware/admin-panel-auth.ts"),
  "admin-panel-noauth": () => import("/app/middleware/admin-panel-noauth.ts"),
  auth: () => import("/app/middleware/auth.ts"),
  "blogger-auth": () => import("/app/middleware/blogger-auth.ts"),
  "career-module-domain-lock": () => import("/app/middleware/career-module-domain-lock.ts"),
  "company-panel-auth": () => import("/app/middleware/company-panel-auth.ts"),
  "company-panel-noauth": () => import("/app/middleware/company-panel-noauth.ts"),
  company: () => import("/app/middleware/company.ts"),
  noauth: () => import("/app/middleware/noauth.ts"),
  "panel-auth": () => import("/app/middleware/panel-auth.ts"),
  "panel-noauth": () => import("/app/middleware/panel-noauth.ts"),
  "payroll-module-domain-lock": () => import("/app/middleware/payroll-module-domain-lock.ts"),
  "support-auth": () => import("/app/middleware/support-auth.ts")
}